import { Professional } from "@/domain/entities/Professional";
import { IProfessionalRepository } from "@/domain/repositories/IProfessionalRepository";
import { IGetProfessionalDetailUseCase } from "@/domain/usecases/IGetProfessionalDetailUseCase";

export class GetProfessionalDetailUseCase implements IGetProfessionalDetailUseCase {
    repository: IProfessionalRepository
    constructor(repository: IProfessionalRepository) {
        this.repository = repository
    }
    async execute(userId: string): Promise<Professional | null> {
        return this.repository.getDetail(userId)
    }
}
